module.exports = __webpack_public_path__ + "static/media/jellee-roman-webfont.d3380bc9.woff2";